import { lazy } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import StatusPage from "./layout/Dashboard/widgets/Statuspage";

export const router = createBrowserRouter([
    {
        path: "", Component: lazy(() => import("./layout/Landing/Index")),
        children: [
            { path: "", Component: lazy(() => import("./pages/LandingPage/Index")) },
            { path: "faq", Component: lazy(() => import("./pages/FAQ/Index")) },
            { path: "sobre-nos", Component: lazy(() => import("./pages/AboutUs/Index")) },
            { path: "privacy-policy", Component: lazy(() => import("./pages/Utilies/PrivacyPolicy")) },
            { path: "terms", Component: lazy(() => import("./pages/Utilies/Terms")) },
            { path: "rede-credenciada", Component: lazy(() => import("./pages/RedeCredenciada/Index")) },
        ]
    },
    { path: "acordo-pagamento/consulta", Component: lazy(() => import("./pages/AnonymousAgreement/Index")) },
    { path: "acordo-pagamento/consulta/:id", Component: lazy(() => import("./pages/Payment/Index")) },
    {
        path: "auth",
        element: (
            <>
                <StatusPage />
                <Outlet />
            </>
        ),
        children: [
            { path: "sign-in", Component: lazy(() => import("./pages/Auth/SignIn")) },
            { path: "confirm-phone-number", Component: lazy(() => import("./pages/Auth/OnBoarding/ConfirmPhoneNumber")) },
            { path: "confirm-email-sent", Component: lazy(() => import("./pages/Auth/OnBoarding/ConfirmEmailSent")) },
            { path: "sign-up", Component: lazy(() => import("./pages/Auth/OnBoarding/SignUp")) },
            { path: "confirm-email", Component: lazy(() => import("./pages/Auth/OnBoarding/ConfirmEmail")) },
            { path: "social/complete", Component: lazy(() => import("./pages/Auth/OnBoarding/CompleteSocialSignUp")) },
            { path: "primeiro-veiculo", Component: lazy(() => import("./pages/Auth/OnBoarding/FirstVehicle")) }
        ]
    },
    {
        path: "app",
        Component: lazy(() => import("./layout/Dashboard/Index")),
        ErrorBoundary: lazy(() => import("./pages/Errors/Page404")),
        children: [
            { path: "cobrancas", Component: lazy(() => import("./pages/Dashboard/Index")) },
            { path: "historico", Component: lazy(() => import("./pages/History/Index")) },
            { path: "meus-veiculos", Component: lazy(() => import("./pages/MyVehicles/Index")) },
            // { path: "meu-cartao", Component: lazy(() => import("./pages/MyCreditCard/Index")) },
            { path: "perfil", Component: lazy(() => import("./pages/Profile/Index")) },
            { path: "configuracao", Component: lazy(() => import("./pages/Configuration/Index")) },
            { path: "acordos-pagamento", Component: lazy(() => import("./pages/Agreements/Index")) },
            { path: "vale-pedagio", Component: lazy(() => import("./pages/ValePedagio/Activate/Index")) },
            { path: "vale-pedagio/autenticado", Component: lazy(() => import("./pages/ValePedagio/Authenticated/AuthenticatedValePedagio")) },
            { path: "vale-pedagio/viagem/:id", Component: lazy(() => import("./pages/ValePedagio/Authenticated/TripDetail")) },
            { path: "vale-pedagio/ativar", Component: lazy(() => import("./pages/ValePedagio/Activate/ActivateProfessionalProfile")) },
            { path: "vale-pedagio/ativar/tipo-usuario", Component: lazy(() => import("./pages/ValePedagio/Activate/steps/ChoiceProfessionalProfileTypeStep")) },
            { path: "vale-pedagio/ativar/form", Component: lazy(() => import("./pages/ValePedagio/Activate/steps/ProfessionalUserFormStep")) },
            { path: "vale-pedagio/ativar/termos", Component: lazy(() => import("./pages/ValePedagio/Activate/steps/ProfessionalProfileTermsStep")) },
            { path: "vale-pedagio/ativar/ativado", Component: lazy(() => import("./pages/ValePedagio/Activate/steps/ProfessionalProfileActivatedStep")) },
            {
                path: "checkout", children: [
                    { path: "", Component: lazy(() => import("./pages/Payment/Index")) },
                    { path: ":orderId", Component: lazy(() => import("./pages/Payment/Index")) },
                    // { path: "success", Component: lazy(() => import("./pages/Payment/Finish/Index")) }
                ]
            },
            { path: 'pagamento', Component: lazy(() => import('./pages/Payment/Index')) },
            { path: "pagamento/concluido", Component: lazy(() => import("./pages/Payment/Finish/Index")) },
            {
                path: "parceiro", children: [
                    // { path: "pagamento/:installmentId", Component: lazy(() => import("./pages/Payment/Partner/Index")) },
                    // { path: "pedido/:orderCoreId", Component: lazy(() => import("./pages/Payment/Partner/Index")) },
                    { path: "pagamento/:installmentId", Component: lazy(() => import("./pages/Payment/Index")) },
                    { path: "pedido/:orderCoreId", Component: lazy(() => import("./pages/Payment/Index")) },
                ]
            },
            { path: "nfs/:invoiceNumber", Component: lazy(() => import("./pages/NFS/Index")) },
            { path: 'sso/zendesk', Component: lazy(() => import("./pages/Sso/Zendesk/Index")) }
        ]
    },
    { path: "mobile/*", Component: lazy(() => import("./pages/Mobile/Index")) },
    { path: "account-deleted", Component: lazy(() => import("./pages/Utilies/AccountDeleted")) },
    // {
    //     path: "comprovante-teste", element: <Receipt order={{
    //         status: OrderStatus.PAID,
    //         orderItems: []
    //     }} />
    // },
    // { path: "iframe", Component: lazy(() => import("./pages/Iframe")) },
    // { path: "app-test", Component: lazy(() => import("./pages/AppTest")) },
    // { path: 'navigation-test', Component: lazy(() => import('./pages/NavigationTest')) },
    { path: "*", Component: lazy(() => import("./pages/Errors/Page404")) }
]);